
import * as __star__ from '@clayui/pagination';

const {
default: __default__,
ClayPaginationWithBasicItems,
__esModule
} = __star__;

export {
ClayPaginationWithBasicItems,
__esModule
};
export default __default__;
